<template>
  <div>
    <div class="container-fluid">
      <div class="card shadow mb-3">
        <div class="row">
          <div class="col-md-2 mt-4">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/inicio">Início</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a style="color: grey; hover: none"> Usuários </a>
                  </li>
                </ol>
                <h3 style="color: #000; margin-left: 15px">Usuários</h3>
              </nav>
            </div>
          </div>
          <div class="col-md-3 offset-7 div_btn_usuario mt-6">
            <div class="form-group">
              <router-link to="/cadastrar-usuario">
                <button
                  style="margin-right: 10px"
                  type="button"
                  class="btn_add"
                >
                  Cadastrar Usuário
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow div_tabela">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="table-responsive" style="background-color: #fff">
              <table
                class="table tablesorter table align-items-center text-center table-flush"
              >
                <thead class="thead-light" style="border: solid 5px white">
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Ação</th>
                </thead>

                <tbody class="list">
                  <corpo-tabela-usuario
                    v-for="usuario in state.usuarios"
                    :key="usuario.id"
                    :usuario="usuario"
                    @deletarUsuario="deletarUsuario"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { onMounted, reactive } from "vue";
import CorpoTabelaUsuario from "../../components/CorpoTabelaUsuario";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  components: {
    CorpoTabelaUsuario,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    const state = reactive({
      usuarios: [],
    });
    onMounted(() => {
      fetchUsuario();
    });
    async function fetchUsuario() {
      try {
        const { data } = await services.usuario.getAll({ token });
        console.log(data);
        state.usuarios = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarUsuario(id) {
      if (confirm("Deseja deletar o usuário?")) {
        try {
          state.isLoading = true;
          const { data } = await services.usuario.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar usuario.");
          } else {
            fetchUsuario();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarUsuario,
    };
  },
};
</script>

<style scoped>
table {
  color: black;
}
.div_btn_usuario {
  text-align: right;
}
.div_tabela {
  height: auto;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>